import React from "react";
import AllServiceBody from "../../Components/AllServiceBodyComponents/AllServiceBody";




import "./AllServices.css";

//import AllServiceBody from "./Components/AllServiceBody";


const AllServices = () => {
  return (
    <div>
      <AllServiceBody />
            
    </div>
  );
};

export default AllServices;
